define('lq/events/actions/checkOut',['jquery', 'lq/events/actions/eventAction', 'lq'],
    function ($, EventAction, lq) {
	    'use strict';

	    function CheckOut(eventData, eventArg) {
	        EventAction.call(this, eventData, eventArg);
	        return this;
	    }

        EventAction.extend(CheckOut, EventAction);

        CheckOut.typeName = 'CheckOut';

	    CheckOut.prototype.getBatchType = function () {
            return EventAction.COMMAND_BATCH;
        };

	    CheckOut.prototype.createEventActionRequest = function () {
            var self = this;

	        return {
	            eventActionType: "CheckOut",
	            morphId: self.eventData.command
	        };
	    };

        CheckOut.prototype.execute = function(continuation, eventActionResponse) {
            var url =
                lq.getTenantUrl('DynamicContent/DownloadFile')
                + '?'
                + $.param({ url: eventActionResponse.Url, filename: eventActionResponse.Filename });
            window.open(url);

            continuation();
        };

	    return CheckOut;
    }
);
